// Plain-language cadence text, matching the server's schedule summary
// ("₹25,000 every month · due on the 5th").

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const CADENCE_PRESETS: Array<{ id: "1" | "3" | "6" | "12"; months: number; label: string }> =
  [
    { id: "1", months: 1, label: "Monthly" },
    { id: "3", months: 3, label: "Quarterly" },
    { id: "6", months: 6, label: "Half-yearly" },
    { id: "12", months: 12, label: "Yearly" },
  ];

export const ordinal = (day: number): string => {
  const rem100 = day % 100;
  if (rem100 >= 11 && rem100 <= 13) {
    return `${day}th`;
  }
  const rem10 = day % 10;
  if (rem10 === 1) {
    return `${day}st`;
  }
  if (rem10 === 2) {
    return `${day}nd`;
  }
  if (rem10 === 3) {
    return `${day}rd`;
  }
  return `${day}th`;
};

export const cadenceText = (intervalMonths: number): string => {
  if (intervalMonths === 1) {
    return "every month";
  }
  if (intervalMonths === 12) {
    return "every year";
  }
  if (intervalMonths % 12 === 0) {
    return `every ${intervalMonths / 12} years`;
  }
  return `every ${intervalMonths} months`;
};

export const dueDayText = (anchorDate: string, intervalMonths: number): string => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(anchorDate);
  if (!match) {
    return "";
  }
  const month = Number(match[2]);
  const day = Number(match[3]);
  if (intervalMonths % 12 === 0) {
    return `due on ${day} ${MONTHS[month - 1]}`;
  }
  return `due on the ${ordinal(day)}${day > 28 ? " (or the month's last day)" : ""}`;
};
